import React from "react";
import type { Reporting, ReportingPeriod } from "../../../api/useReporting";

export function useReportingPeriodLimit(
  reporting: Reporting,
  reportingPeriod: ReportingPeriod | null,
) {
  return React.useMemo(() => {
    const periods = reporting.periods.map(p => p.period);
    const maxFrom = reportingPeriod!.min;
    const maxTo = reportingPeriod!.max;
    const maxPeriod = Math.max(...periods);

    return {
      from: new Date(maxFrom).getTime(),
      to: Math.min(maxPeriod, new Date(maxTo).getTime()),
    };
  }, [reporting, reportingPeriod]);
}
